//Fix rules
import { useDisclosure } from '@chakra-ui/react';
import { BaseButton } from '@cks-internal/react-base';
import { useEffect } from 'react';
import { CoordinatorWidget } from '../../features/workflow/CoordinatorWidget';
import { CurrentUser } from '../../features/workflow/CurrentUser';
import { JoinWorkflowForm } from '../../features/workflow/forms/JoinWorkflowForm';
import { ConnectionType } from '../../features/workflow/types';
import { useWorkflowSocket } from '../../features/workflow/hub/useWorkflowSocket';
import { useWidgetStore } from '../../features/workflow/widgetStore';
import { faSailboat } from '@fortawesome/free-solid-svg-icons';
import { useGroupName } from '../../features/workflow/utils/useGroupName';
import { useGroupType } from '../../features/workflow/utils/useGroupType';

export const WfTool = () => {
  const data = useWorkflowSocket((r) => r.data);
  const reset = useWorkflowSocket((r) => r.data?.inactive);
  const invoke = useWorkflowSocket((r) => r.invoke);
  const autoJoin = useWorkflowSocket((r) => r.initalJoin);
  const joinDisclosure = useDisclosure();
  const store = useWidgetStore();
  const group = useGroupType();
  const wfType = useGroupName(group);

  useEffect(() => {
    if (autoJoin && !reset) {
      joinDisclosure.onOpen();
    }
  }, [autoJoin, reset]);

  if (data?.user?.ConnectionType == undefined) {
    return (
      <>
        <JoinWorkflowForm disclosure={joinDisclosure} trigger={<BaseButton>Join {wfType} Workflow</BaseButton>} />
      </>
    );
  }
  return (
    <>
      {data.user.ConnectionType != ConnectionType.Spectator ? (
        <CurrentUser />
      ) : (
        <BaseButton
          backgroundColor={'secondary'}
          onClick={() => {
            invoke('Leave', false);
          }}>
          Leave Workflow Spectator
        </BaseButton>
      )}
      {(data?.user?.ConnectionType == ConnectionType.Spectator ||
        data?.user?.ConnectionType == ConnectionType.Coordinator) && <CoordinatorWidget />}
      {store.docked && <BaseButton toolTip={'show workflow popup'} onClick={store.toggleDock} icon={faSailboat} />}
    </>
  );
};
